import React, { useEffect, useState } from "react";
import ChatUI from "../chat";
import Lottie from "react-lottie-player";
import chatbot from "../assest/chatbot.json";
import chatbotClose from "../assest/close.json";
function BubbleLayout() {
  const [play, setPlay] = useState(true);
  const [showChat, setShowChat] = useState(false);
  const [parentUrl, setParentUrl] = useState("");
  useEffect(() => {
    setPlay(true);
    const timeout = setTimeout(
      () => {
        setPlay(false);
      },
      showChat ? 600 : 1500
    );

    return () => clearTimeout(timeout);
  }, [showChat]);

   useEffect(() => {
    const TIMER_KEY = "introductionTimer";
    const INTRO_DURATION = 120000; // 2 minutes

    const startTimer = () => {
      const currentTime = Date.now();
      localStorage.setItem(TIMER_KEY, currentTime.toString());
      setTimeout(() => {
        setShowIntroduction(true);
        localStorage.removeItem(TIMER_KEY); // Clean up after showing the introduction
      }, INTRO_DURATION);
    };

    const storedTime = localStorage.getItem(TIMER_KEY);

    if (storedTime) {
      const elapsed = Date.now() - parseInt(storedTime);
      if (elapsed >= INTRO_DURATION) {
        setShowIntroduction(true); 
        localStorage.removeItem(TIMER_KEY);
        startTimer();
      } else {
        const remainingTime = INTRO_DURATION - elapsed;
        setTimeout(() => {
          setShowIntroduction(true);
          localStorage.removeItem(TIMER_KEY);
        }, remainingTime);
      }
    } else {
      
      startTimer();
    }

  }, []);

  useEffect(() => {
    const handleMessage = (event: {
      data: { type: string; url: React.SetStateAction<string> };
    }) => {
      if (event.data.type === "parent-url") {
        setParentUrl(event.data.url); // Set the parent URL
        console.log("Parent URL:", event.data.url);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const [showIntroduction, setShowIntroduction] = useState(false);
  useEffect(() => {
    const message = {
      type: "chat-widget-resize",
      state: showChat ? "Chat" : showIntroduction ? "Introduction" : "Closed",
      element: "chat-widget",
    };
    window.parent.postMessage(message, "*");
  }, [showChat, showIntroduction]);

  return (
    <div className="fixed bottom-3 right-3 z-50">
      {showIntroduction && (
        <div className="relative mb-3 animate-fadeIn">
          <div className="text-xs text-slate-700 dark:text-slate-200 flex flex-col gap-2">
            <button
              className="ml-auto p-1.5 shadow-md rounded-lg text-slate-400 hover:text-slate-800 dark:hover:text-white bg-white dark:bg-[#131622] border border-slate-200 dark:border-white/10 transition-colors"
              onClick={() => setShowIntroduction(false)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <p className="font-semibold px-3 py-2 shadow-lg rounded-xl bg-white dark:bg-[#131622] border border-slate-200 dark:border-white/10">
              Bonjour, je suis Continuum
            </p>
            <p className="px-3 py-2 shadow-lg rounded-xl bg-white dark:bg-[#131622] border border-slate-200 dark:border-white/10">
              Comment puis-je vous aider ?
            </p>
          </div>
        </div>
      )}
      <div
        className={`relative rounded-full cursor-pointer w-14 h-14 ml-auto bg-gradient-to-tr from-purple-600 via-indigo-600 to-cyan-500 shadow-glow-purple border border-white/20 flex items-center justify-center hover:scale-105 transition-transform ${
          showChat ? "" : "p-2"
        }`}
      >
        {showChat ? (
          <Lottie
            animationData={chatbotClose}
            style={{ height: "55px", width: "55px" }}
            play={play}
            onClick={() => setShowChat(!showChat)}
            className="mr-0.5 invert"
          />
        ) : (
          <Lottie
            animationData={chatbot}
            style={{ height: "42px", width: "42px" }}
            play={play}
            onClick={() => setShowChat(!showChat)}
            className="brightness-0 invert"
          />
        )}
      </div>
      <div
        className={`absolute bottom-16 right-0 h-[480px] w-[360px] shadow-2xl rounded-2xl overflow-hidden border border-slate-200 dark:border-white/10 duration-300 transition-all ${
          showChat ? "translate-y-0 opacity-100 scale-100" : "translate-y-4 opacity-0 scale-95 pointer-events-none"
        }`}
      >
        <ChatUI isBubble={true} parentUrl={parentUrl} />
      </div>
    </div>
  );
}

export default BubbleLayout;
